"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _isString2 = _interopRequireDefault(require("lodash/isString"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

require("core-js/modules/es6.function.bind.js");

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactComponents = require("@ucloud-fe/react-components");

var _Label = _interopRequireDefault(require("./Label"));

var _style = require("./style");

var _excluded = ["label", "labelTag", "labelSize", "marginSize", "labelCol", "controllerCol", "children"];

var _this = void 0;

var Col = _reactComponents.Grid.Col;
/**
 * ChargeInfo.Item
 * @description 计费UI组件-表单项
 */

var Item = function Item(_ref) {
  (0, _newArrowCheck2["default"])(this, _this);
  var label = _ref.label,
      labelTag = _ref.labelTag,
      labelSize = _ref.labelSize,
      marginSize = _ref.marginSize,
      labelCol = _ref.labelCol,
      controllerCol = _ref.controllerCol,
      children = _ref.children,
      others = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var labelNode = label;

  if ((0, _isString2["default"])(label)) {
    labelNode = /*#__PURE__*/_react["default"].createElement(_Label["default"], {
      size: labelSize,
      tag: labelTag
    }, label);
  }

  return /*#__PURE__*/_react["default"].createElement(_style.StyledItemWrapper, (0, _extends2["default"])({
    marginSize: marginSize,
    type: "flex",
    align: "middle",
    gutter: 0
  }, others), /*#__PURE__*/_react["default"].createElement(Col, labelCol, labelNode), /*#__PURE__*/_react["default"].createElement(Col, (0, _extends2["default"])({}, controllerCol, {
    className: "".concat(_style.prefixCls, "-item-wrapper-controller")
  }), children));
}.bind(void 0);

var colShape = {
  /** 栅格占位格数 */
  span: _propTypes["default"].number,

  /** 栅格向右偏移格数，偏移占位 */
  offset: _propTypes["default"].number,

  /** 栅格向左偏移格数，偏移不占位 */
  pull: _propTypes["default"].number,

  /** 栅格向右偏移格数，偏移不占位 */
  push: _propTypes["default"].number
};
Item.propTypes = {
  /** 表单项的标题 */
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /** 表单项标题旁的图标标注 */
  labelTag: _propTypes["default"].node,

  /** 表单项的标题尺寸 */
  labelSize: _propTypes["default"].oneOf(["sm", "md", "lg"]),

  /** 表单项的间距尺寸 */
  marginSize: _propTypes["default"].oneOf(["xs", "sm", "md", "lg", "xlg"]),

  /** 标签的col配置 */
  labelCol: _propTypes["default"].shape(colShape),

  /** 控件的col配置 */
  controllerCol: _propTypes["default"].shape(colShape),
  children: _propTypes["default"].node
};
Item.defaultProps = {
  labelSize: "lg",
  marginSize: "lg",
  labelCol: {
    span: 5
  },
  controllerCol: {
    span: 7
  }
};
var _default = Item;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/ChargeInfo/Item.js
// module id = 1413
// module chunks = 6 7 17 18